import { useEffect } from 'react';
import { usePositionStore } from '@/feature/terminal_tables/position/PositionStore.ts';
import type { ViewPosition } from '@/feature/terminal_tables/position/types.ts';
import { createShortcutTarget } from '@/utils/shortcutTarget';
import useAppStore from '../../../store/rootStore.ts';
import type { ClosePositionOptions } from './useClosePosition';

/** C: close the selected market's position through the mounted positions table. */
export const closeSelectedPosition = createShortcutTarget();

/**
 * Uses this table's close flow (posting mode, stale close-order handling). Always via the confirmation
 * dialog, and not while an order is posting, like the row's disabled Close button.
 */
export function useClosePositionShortcut(
  closePosition: (position: ViewPosition, options?: ClosePositionOptions) => void,
  isPosting: boolean
) {
  useEffect(
    () =>
      closeSelectedPosition.register(() => {
        if (isPosting) return false;
        const { selectedMarketId } = useAppStore.getState();
        const position = usePositionStore.getState().positions.find((p) => p.marketId === selectedMarketId && p.size > 0);
        if (!position) return false;
        closePosition(position, { alwaysConfirm: true });
        return true;
      }),
    [closePosition, isPosting]
  );
}
